import React, { useEffect, useState } from 'react';

import { AuthState, useAuth } from '@app/hooks/useAuth';

import VerifyModal from './index';

export default function VerifyModalMount() {
  const { isAuth } = useAuth();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {isAuth === AuthState.AUTH && (
        <VerifyModal
          isOpen={isOpen}
          onClose={() => {
            setIsOpen(false);
          }}
        />
      )}
    </>
  );
}
